import request from '@/utils/request'

/** 聊天会话列表 */
export function getSessions(params) {
  return request({
    url: '/Field_bee_client/sessions',
    method: 'get',
    params
  })
}

/** 聊天记录 */
export function getChatLogs(params) {
  return request({
    url: '/Field_bee_client/chatLogs',
    method: 'get',
    params
  })
}
